exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.comment-card{position:absolute;background-color:#fff;border-bottom:1px solid #e0e0e0;overflow:hidden}.comment-card.selected{background-color:#f8f8f8}.comment-card.borderless{border:none}.comment-card.borderless .comment-caption{top:-10px;overflow:hidden;width:400px}.comment-card.borderless .comment-date{top:11px}.comment-card.borderless .menu-dots{top:20px}.comment-card .comment-caption{font-size:14px;color:#000;font-weight:400;top:-7px;letter-spacing:.82px}.comment-card .comment-caption,.comment-card .comment-date{position:absolute;font-family:Open Sans,sans-serif;left:44px}.comment-card .comment-date{font-size:11px;color:#8b8b8b;font-weight:600;top:10px}.comment-card .menu-dots{position:absolute;right:-20px;top:16px;height:3px;width:17px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ProjectsContainer/ProjectHierarchy/SubHeader/CommentCard/CommentCard.scss
// module id = 1822
// module chunks = 0